import React, { useState } from 'react';
import Lightbox from 'react-image-lightbox'; // Use a lightbox library
import 'react-image-lightbox/style.css'; // Import CSS for the lightbox

const PortfolioSection = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const images = [
        "/images/gallery/01.jpeg",
    "/images/gallery/03.jpeg",
    "/images/gallery/04.jpeg",
    "/images/gallery/02.jpeg",

    "/images/gallery/05.jpeg",
    "/images/gallery/06.jpeg",
    "/images/gallery/07.jpeg",
    "/images/gallery/08.jpeg",
    "/images/gallery/8.jpg",
    "/images/gallery/09.jpeg",
    "/images/gallery/10.jpeg",


    // "/images/gallery/11.jpg" ,
//  "/images/gallery/12.jpg",
//   "/images/gallery/15.jpeg",
// "/images/gallery/16.png" ,
//  "/images/gallery/17.png" ,
//  "/images/gallery/20.png" ,
//  "/images/gallery/21.png" ,


//  "/images/gallery/23.png" ,



//  "/images/gallery/24.png" ,
//  "/images/gallery/25.png" ,
//  "/images/gallery/26.png" ,
//  "/images/gallery/27.png" ,

    "/images/gallery/1.jpg",
    // "/images/gallery/3.jpg",
    // "/images/gallery/4.jpg",
    // "/images/gallery/2.jpg",

    // "/images/gallery/5.jpg",
    // "/images/gallery/6.jpg",
    // "/images/gallery/7.jpg",
    // "/images/gallery/8.jpg",
 
  






  ];

  // const vehicleNames = [
  //    "SWIFT DESIRE",
  //     "Aura",
  //   "Hyundai City",
  //   "Ertiga",
  //   "Toyota Innova Crysta",
  //   "Kia Carens",
  //   "Maruti Suzuki Ciaz",
  //   "Maruti Suzuki Invicto",
  //   "Toyota Innova Crysta (Diesel)",
  //   "Toyota Innova Hycross",
   
  // ];

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setIsOpen(true);
  };

  const closeLightbox = () => {
    setIsOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <div>
    <section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1>Gallery</h1>
        </div>
      </div>
    </section>

    

      <div className="section-full site-bg-white p-t150 p-b120 twm-portfolio-wrap wow fadeInDown" data-wow-offset="100" data-wow-delay="0.2">
        <div className="container">
          <ul className="masonry-outer mfp-gallery work-grid row clearfix list-unstyled m-b0">
            {images.map((image, index) => (
            












<li key={index} className={`masonry-item cat-${(index % 4) + 1} col-lg-4 col-md-6 m-b30`}>
  <div className="gallery-card">
    <a className="gallery-link" href="#" onClick={() => openLightbox(index)}>
      <div className="gallery-img">
        <img src={image} />
        <div className="gallery-overlay">
          <span className="icon-view"><i className="feather feather-maximize"></i></span>
        </div>
      </div>
    </a>
    <div className="gallery-info">
      {/* <h3 className="gallery-title">{vehicleNames[index]}</h3> */}
    </div>

    {/* Logo Watermark */}
    <div className="gallery-logo">
      <img src="/images/logo.jpg" alt="Pune Corporate car Logo" />
    </div>
  </div>
</li>



            ))}
          </ul>

          {/* Lightbox Modal */}
          {isOpen && (
            <Lightbox
              mainSrc={images[currentImageIndex]}
              nextSrc={images[(currentImageIndex + 1) % images.length]}
              prevSrc={images[(currentImageIndex - 1 + images.length) % images.length]}
              onCloseRequest={closeLightbox}
              onMovePrevRequest={prevImage}
              onMoveNextRequest={nextImage}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PortfolioSection;
